<template>
  <div>
    <div class="header">
      <div>
        <img
          @click="goToDashboard()"
          class="logo pointer"
          src="/slicingPie-logo.png"
        />
      </div>
      <div class="items">
        <!-- Home -->
        <div @click="goToDashboard()" class="item me-4">
          <v-icon>mdi-home-outline</v-icon> داشبورد
        </div>
        <!-- Other -->
        <div class="item me-4" v-if="role != 'admin'">
          <a
            href="https://slicingpie.ir/"
            target="_blank"
            style="text-decoration: none; color: #555"
          >
            <v-icon>mdi-help-circle-outline</v-icon> راهنما</a
          >
        </div>
        <v-menu
          v-for="(item, index) in menu"
          :key="index"
          open-on-hover
          bottom
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="item" v-bind="attrs" v-on="on">
              <v-icon>{{ item.icon }}</v-icon>
              {{ item.name }}
              <v-icon class="chevron-icon">mdi-chevron-down</v-icon>
            </div>
          </template>
          <v-list>
            <v-list-item
              v-for="(item2, index) in item.children"
              :key="index"
              @click="
                item2.name != 'خروج' ? $router.push(item2.link) : logout()
              "
              :class="
                role == 'admin' && item2.name == 'تنظیمات حساب کاربری'
                  ? 'd-none'
                  : ''
              "
            >
              <v-list-item-title v-if="item2.name != 'خروج'">
                <v-icon>{{ item2.icon }}</v-icon>
                {{ item2.name }}
              </v-list-item-title>
              <v-list-item-title v-else>
                <v-icon>{{ item2.icon }}</v-icon>
                {{ item2.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Notification -->
        <div
          class="item me-4 icon-relative"
          @click="
            getNotifUnseen();
            openNotifDialog();
            nonePanel();
          "
          v-if="role != 'admin'"
        >
          <v-icon>mdi-bell-outline</v-icon>
          <div
            v-if="notificationCount > 0"
            class="pa-1 white--text chip-absolute chip"
            color="green"
            style="font-size: 0.8rem; min-width: 22px; height: 22px"
          >
            {{ notificationCount }}
          </div>
        </div>
        <!-- Notification-Modal -->
        <v-dialog v-model="notifDialog" max-width="700">
          <!-- LOADING -->
          <v-card class="pa-1">
            <div
              v-if="busy"
              class="d-flex flex-column align-items-center mt-8 py-6"
            >
              <spring-spinner
                :animation-duration="1500"
                :size="60"
                color="#bf0000"
                class="mx-auto"
              />
              <p class="primary--text mx-auto font-weight-bold mt-6">
                در حال بارگذاری...
              </p>
            </div>
            <div v-else>
              <template>
                <v-container fluid>
                  <div class="px-1">
                    <span @click="notifDialog = false"
                      ><v-icon
                        style="position: absolute; top: 20px; left: 20px"
                        class="dark-text mb-1 pointer"
                        small
                        >mdi-close</v-icon
                      >
                    </span>
                    <v-card-title class="mb-3">پیام‌های جدید</v-card-title>
                  </div>

                  <div class="px-2" v-if="!messages.length">
                    <h3 class="mr-4 text-color fs-small">
                      <v-icon class="primary--text"
                        >mdi-alert-circle-outline</v-icon
                      >
                      پیام جدیدی برای نمایش وجود ندارد!
                    </h3>
                  </div>

                  <div v-else>
                    <v-expansion-panels v-model="panel">
                      <v-expansion-panel
                        v-for="(message, i) in messages"
                        :key="i"
                        hide-actions
                      >
                        <v-expansion-panel-header>
                          <template v-slot:default="{ open }">
                            <v-row class="py-1 d-flex align-center">
                              <v-col
                                class="message-img text-right ml-sm-2"
                                cols="3"
                                sm="1"
                              >
                                <img
                                  v-if="message.mediaURL"
                                  :src="message.mediaURL"
                                />
                                <v-gravatar
                                  v-else
                                  class="gravatar rounded-circle"
                                  :email="message.SenderEmail"
                                />
                              </v-col>
                              <v-col cols="7" sm="3">
                                <strong
                                  class="fs-small"
                                  v-html="message.senderName"
                                ></strong>
                                <span
                                  v-if="message.total"
                                  class="grey--text mx-auto"
                                >
                                  &nbsp;({{ message.total }})
                                </span>
                              </v-col>

                              <v-col class="text-center" v-if="!open">
                                <v-chip
                                  v-if="message.new"
                                  :color="`${message.color} lighten-4`"
                                  class="ml-0 mr-2 black--text"
                                  label
                                  small
                                >
                                  {{ message.new }} new
                                </v-chip>
                              </v-col>
                            </v-row>
                          </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-divider></v-divider>
                          <div
                            class="grey--text text--darken-2 fs-medium d-flex mt-4"
                          >
                            <div class="bold ml-1">موضوع:</div>
                            <div>{{ message.title }}</div>
                          </div>
                          <div
                            class="grey--text text--darken-2 fs-medium d-flex mt-2"
                          >
                            پیام ارسالی از {{ message.PieName }}
                          </div>
                          <v-card-text
                            v-text="message.text"
                            class="ps-0 pt-8 text-justify"
                          ></v-card-text>
                          <div class="text-left">
                            <v-btn
                              :disabled="!message.userRole"
                              @click="goToMessagePie(message)"
                              class="primary--text"
                              text
                              ><span class="font-weight-bold"
                                >مشاهده کیک سهام</span
                              ></v-btn
                            >
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </v-container>
              </template>

              <div class="text-left ma-4">
                <v-btn
                  class="info white--text me-3"
                  @click="openSecondNotifDialog()"
                  >همه پیام‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌ها</v-btn
                >
                <v-btn class="primary white--text" @click="notifDialog = false"
                  >بستن</v-btn
                >
              </div>
            </div>
          </v-card>
        </v-dialog>
        <!-- Notification-Modal -->
        <v-dialog v-model="secondNotifDialog" max-width="700">
          <!-- LOADING -->
          <v-card class="pa-1">
            <div
              v-if="busy"
              class="d-flex flex-column align-items-center mt-8 py-6"
            >
              <spring-spinner
                :animation-duration="1500"
                :size="60"
                color="#bf0000"
                class="mx-auto"
              />
              <p class="primary--text mx-auto font-weight-bold mt-6">
                در حال بارگذاری...
              </p>
            </div>
            <div v-else>
              <template>
                <v-container fluid>
                  <v-row justify="center" class="px-sm-3 px-0">
                    <v-card-title class="pa-2">
                      <span @click="secondNotifDialog = false"
                        ><v-icon
                          style="position: absolute; top: 20px; left: 20px"
                          class="dark-text mb-1 pointer"
                          small
                          >mdi-close</v-icon
                        >
                      </span>
                      <v-card-title class="mb-3"
                        >لیست همه پیام‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌‌ها
                      </v-card-title>
                    </v-card-title>

                    <v-card-text>
                      <v-text-field
                        v-model="messageFilter"
                        outlined
                        dense
                        placeholder="جستجو"
                      ></v-text-field>
                      <div
                        v-if="!messageFilter && !computedMessagesList.length"
                      >
                        <h3 class="text-color fs-small">
                          <v-icon class="primary--text"
                            >mdi-alert-circle-outline</v-icon
                          >
                          پیامی برای نمایش وجود ندارد!
                        </h3>
                      </div>
                      <div
                        v-else-if="
                          messageFilter && !computedMessagesList.length
                        "
                      >
                        <h3 class="mx-auto text-center fs-small">
                          نتیجه ای برای <b>"{{ messageFilter }}"</b> یافت نشد.
                        </h3>
                      </div>
                      <div v-else>
                        <v-expansion-panels v-model="panel2">
                          <v-expansion-panel
                            v-for="(message, i) in computedMessagesList"
                            :key="i"
                            hide-actions
                          >
                            <v-expansion-panel-header>
                              <template v-slot:default="{ open }">
                                <v-row class="py-1 d-flex align-center">
                                  <v-col
                                    class="message-img text-right ml-sm-2"
                                    cols="3"
                                    sm="1"
                                  >
                                    <img
                                      v-if="message.SenderPicture"
                                      :src="message.SenderPicture"
                                    />
                                    <v-gravatar
                                      v-else
                                      class="gravatar rounded-circle"
                                      :email="message.SenderEmail"
                                    />
                                  </v-col>
                                  <v-col cols="7" sm="3">
                                    <strong
                                      class="fs-small"
                                      v-html="message.senderName"
                                    ></strong>
                                  </v-col>

                                  <v-col class="text-center" v-if="!open">
                                    <!-- <v-chip
                                  v-if="message.new"
                                  :color="`${message.color} lighten-4`"
                                  class="ml-0 mr-2 black--text"
                                  label
                                  small
                                >
                                  {{ message.new }}
                                </v-chip> -->
                                    <span
                                      class="fs-small grey--text text--darken-1 hidden-xs-only"
                                      >{{
                                        message.title.length > 15
                                          ? message.title.slice(0, 15) + "..."
                                          : message.title
                                      }}</span
                                    >
                                  </v-col>

                                  <!-- <v-col
                                  v-if="message.text"
                                  class="grey--text text-truncate hidden-sm-and-down"
                                >
                                  &mdash;
                                  {{
                                    message.text.length > 30
                                      ? message.text.slice(0, 30) + "..."
                                      : message.text
                                  }}
                                </v-col> -->
                                </v-row>
                              </template>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <v-divider></v-divider>
                              <div
                                class="grey--text text--darken-2 fs-medium d-flex mt-4"
                              >
                                <div class="bold ml-1">موضوع:</div>
                                <div>{{ message.title }}</div>
                              </div>
                              <div
                                class="grey--text text--darken-2 fs-medium d-flex mt-2"
                              >
                                پیام ارسالی از {{ message.PieName }}
                              </div>
                              <v-card-text
                                v-text="message.text"
                                class="ps-0 pt-8 text-justify"
                              ></v-card-text>
                              <div class="text-left">
                                <v-btn
                                  :disabled="!message.userRole"
                                  @click="goToMessagePie(message)"
                                  class="primary--text"
                                  text
                                  ><span class="font-weight-bold"
                                    >مشاهده کیک سهام</span
                                  ></v-btn
                                >
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-card-text>
                  </v-row>
                </v-container>
              </template>

              <div class="text-left ma-4">
                <v-btn
                  class="primary white--text"
                  @click="secondNotifDialog = false"
                  >بستن</v-btn
                >
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>
      <div class="d-sm-none d-flex">
        <!-- Notification -->
        <div
          class="item me-5 mt-5 icon-relative"
          @click="
            getNotifUnseen();
            openNotifDialog();
            nonePanel();
          "
          v-if="role != 'admin'"
        >
          <v-icon>mdi-bell-outline</v-icon>
          <div
            v-if="notificationCount > 0"
            class="pa-1 white--text nav-chip-absolute chip pointer"
            color="green"
          >
            {{ notificationCount }}
          </div>
        </div>
        <div class="d-md-none d-block pe-4 pt-5 pointer" @click="drawer = true">
          <v-icon>mdi-menu</v-icon>
        </div>
      </div>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      left
      style="position: fixed"
    >
      <nav dense dir="ltr" class="mt-3">
        <v-list rounded class="white">
          <v-list-item @click="goToDashboard()">
            <v-list-item-icon>
              <v-icon>mdi-home-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> داشبورد </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="role != 'admin'">
            <a
              href="https://slicingpie.ir/"
              target="_blank"
              style="text-decoration: none; color: #000000de"
            >
              <v-icon class="ms-3 fs-xlarge">mdi-help-circle-outline</v-icon>
              راهنما</a
            >
          </v-list-item>

          <v-list-group
            v-for="(item, index) in menu"
            :key="index"
            :value="false"
            :prepend-icon="item.icon"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </template>
            <v-list-item
              v-for="(item2, index) in item.children"
              :key="index"
              @click="
                item2.name != 'خروج' ? $router.push(item2.link) : logout()
              "
              class="me-4"
              :class="
                role == 'admin' && item2.name == 'تنظیمات حساب کاربری'
                  ? 'd-none'
                  : ''
              "
            >
              <template>
                <v-list-item-icon>
                  <v-icon>{{ item2.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item2.name }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-group>
        </v-list>
      </nav>
    </v-navigation-drawer>
  </div>
</template>

<script>
const MVPInfo = () => import("@/components/MVPInfo");
import { mapGetters, mapMutations } from "vuex";
import { SpringSpinner } from "epic-spinners";
export default {
  components: { MVPInfo, SpringSpinner },
  data() {
    return {
      role: "",
      messages: [],
      messageList: [],
      busy: false,
      notificationCount: "",
      summaryList: [],
      infoDialog: false,
      notifDialog: false,
      secondNotifDialog: false,
      title: "",
      drawer: false,
      selectedId: "",
      panel: null,
      panel2: null,
      messageFilter: "",
    };
  },
  methods: {
    nonePanel() {
      this.panel2 = null;
    },
    ...mapMutations(["setUserName"]),
    logout() {
      window.localStorage.clear();
      window.location.replace("/");
    },
    goToMessagePie(message) {
      localStorage.setItem("role", message.userRole);
      localStorage.setItem("restriction", message.restriction);
      localStorage.setItem("selectedPie", message.PieId);
      this.$router.push("/home/" + message.PieId);
      this.$router.go("/home/" + message.PieId);
      this.secondNotifDialog = false;
    },
    openDialog(name) {
      this.title = name;
      this.infoDialog = true;
    },
    openNotifDialog() {
      this.notifDialog = true;
    },
    openSecondNotifDialog() {
      this.notifDialog = false;
      this.secondNotifDialog = true;
      this.getNotifList();
    },
    goToDashboard() {
      if (this.role == "admin") {
        this.$router.push("/adminDashboard");
      } else {
        this.$router.push("/dashboard");
      }
    },
    getNotifCount() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/news/count", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.notificationCount = res.data.newsCount;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          // if (err.response.status == 420) {
          //   if (this.role == "manager") {
          //     this.role = "employee";
          //   } else {
          //     this.role = "manager";
          //   }
          //   this.getInfo();
          // } else {
          //   this.toast("خطا: " + err.response.data, "error");
          // }

          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getNotifUnseen() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/news/getunseen", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.messages = res.data;
            this.notificationCount = 0;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getNotifList() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/news/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.messageList = res.data;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  computed: {
    ...mapGetters(["userName"]),
    menu() {
      return [
        //{
        //  name: "راهنما",
        //  icon: "mdi-help-circle-outline",
        //  children: [
        //    {
        //      name: "راهنمای کاربر",
        //      icon: "mdi-book-open-variant",
        //      link: "",
        //    },
        //    {
        //      name: "تماس با پشتیبانی",
        //      icon: "mdi-forum-outline",
        //      link: "",
        //    },
        //    {
        //      name: "دفترچه راهنما",
        //      icon: "mdi-book-open-outline",
        //      link: "",
        //    },
        //  ],
        //},
        {
          name: this.userName ? this.userName : "بدون نام",
          icon: "mdi-account-outline",
          children: [
            {
              name: "تنظیمات حساب کاربری",
              icon: "mdi-cog-outline",
              link: "/settings-account",
            },
            {
              name: "گزارش خطا",
              icon: "mdi-bug",
              link: "/bug-report",
            },
            {
              name: "خروج",
              icon: "mdi-power",
              link: "",
            },
          ],
        },
      ];
    },
    computedMessagesList() {
      let filtered = [];
      filtered = this.messageList.filter(
        (x) =>
          x.senderName.includes(this.messageFilter) ||
          x.title.includes(this.messageFilter)
      );
      return filtered;
    },
  },
  watch: {},
  mounted() {
    this.role = localStorage.getItem("role");
    this.setUserName(localStorage.getItem("name"));
    if (this.role) {
      this.getNotifCount();
    }
  },
};
</script>

<style lang="scss">
.gravatar {
  width: 55px;
  height: 55px;
}
.icon-relative {
  position: relative;
}
.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  min-width: 22px;
  height: 22px;
  border-radius: 50px;
  background-color: #4caf50;
}
.chip-absolute {
  position: absolute;
  top: 10px;
  left: 17px;
}
.nav-chip-absolute {
  position: absolute;
  top: -10px;
  left: 8px;
}
.header {
  background-color: #fff;
  height: 65px;
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 0 110px;
  display: flex;
  justify-content: space-between;

  .logo {
    width: 65px;
    margin-top: 2px;
  }
  .items {
    display: flex;
    align-items: center;
    .item {
      margin-right: 28px;
      font-size: 0.9rem;
      color: #555;
      height: 65px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .v-icon {
        font-size: 1.6rem;
        color: #555;
        margin-left: 7px;
      }
      .chevron-icon {
        font-size: 1.2rem;
        margin-right: 4px;
      }
    }
  }
  @media only screen and (max-width: 599px) {
    padding: 0 15px;
    .items {
      display: none;
    }
  }
}

.v-list-item__icon {
  margin-left: 0 !important;
  margin-right: 15px !important;
}
.v-list-item__title {
  font-size: 14px !important;
}
.text-color {
  color: #bf0000;
}
// .v-expansion-panel::before {
//   border-radius: 0;
//   -webkit-transition: none;
//   transition: none;
//   box-shadow: none;
//   -webkit-box-shadow: none;
//   border: 1px solid #000;
// }
// // .v-expansion-panel-content__wrap {
// //   border-bottom: 1px solid #ccc;
// // }
// .v-expansion-panels .v-expansion-panel .v-expansion-panel-hedear {
//   border-top: 1px solid #ccc;
// }
</style>
